export const juniorWebDesignerResume = `
【職務概要】
Webデザイナーとして2年の実務経験を持ち、特にLP制作とバナーデザインを得意としています。ユーザー体験を重視したUI/UXデザインに強みがあり、Adobe Creative Suiteの各ツールに精通しています。直近では、HTML/CSSのコーディングスキルを活かし、レスポンシブデザインの実装にも積極的に取り組んでいます。

キャリアの初期段階ですが、複数のプロジェクトにおいて主担当を務め、クライアントの要望を的確に捉えたデザイン提案から実装までを一貫して担当してきました。特にゲーム関連サイトやECサイトでのユーザー動線設計には定評があり、コンバージョン率の向上に貢献してきました。

近年のWebデザイントレンドや最新のデザインツールへの理解も深く、Figmaを活用したプロトタイピングやSTUDIOなどのノーコードツールにも積極的に取り組んでいます。今後はよりデザイン思考を深め、マーケティング施策との連携を強化したWebデザインのスペシャリストを目指しています。

【職務経歴】
・株式会社Algomaticデザインスタジオ（2022年4月〜現在）
  ○ 会社概要：Webサイト制作、広告デザイン、グラフィックデザインを手がける制作会社。従業員約30名。
  ○ 就業期間：2022年4月〜現在
  ○ 職務内容：
    - コーポレートサイト、LP、バナー制作などのWebデザイン業務全般
    - クライアントとの打ち合わせからデザイン提案、納品までを担当
    - HTML/CSSを用いたコーディング実装
    - 社内デザインガイドラインの整備と運用
  ○ 具体的な成果：
    - ゲーム関連企業のLPデザインを担当し、コンバージョン率が前年比30%向上
    - 自社内の制作フローを改善し、制作期間を平均20%短縮
    - バナー広告のA/Bテストを積極的に提案・実施し、クリック率の向上に貢献
  ○ 使用した技術・ツール：Photoshop、Illustrator、XD、Figma、HTML/CSS、JavaScript（jQuery）
  ○ 身につけたスキル：ユーザー分析に基づいたUI/UXデザイン、グリッドシステムを活用したレイアウト設計

・株式会社Algomatic技研（2021年4月〜2022年3月）
  ○ 会社概要：Webマーケティングソリューションを提供する企業。従業員約50名。
  ○ 就業期間：2021年4月〜2022年3月
  ○ 職務内容：
    - 広告バナーのデザイン制作
    - SNS広告用クリエイティブの制作
    - クライアント向けプレゼン資料の作成
  ○ 具体的な成果：
    - 月間平均120件のバナー制作に対応し、納期遵守率100%を達成
    - デザインテンプレートを作成し、制作効率を50%向上
  ○ 使用した技術・ツール：Photoshop、Illustrator、After Effects
  ○ 身につけたスキル：短納期での効率的な制作ワークフロー構築、広告効果を考慮したデザイン制作

【受賞・表彰歴】
・2023年 株式会社Algomaticデザインスタジオ「優秀デザイナー賞」受賞
・2023年 社内デザインコンペティション「最優秀賞」受賞（ECサイトのリニューアルデザイン提案）
・2022年 新人デザイナーコンテスト「奨励賞」受賞

【資格】
・Webデザイン技能検定 2級（2022年10月取得）
・Adobe Certified Professional - Photoshop（2021年8月取得）
・Adobe Certified Professional - Illustrator（2022年2月取得）
・HTML5プロフェッショナル認定試験 レベル1（2023年3月取得）

【マネジメント経験】
・2023年9月〜現在：新人デザイナー1名の育成担当
・2023年7月〜9月：夏季インターン生（2名）のメンター担当
  ○ デザイン作業の指導やフィードバックを行い、両名ともに基本的なデザインスキルを習得

【語学力】
・英語：日常会話レベル
  ○ TOEIC スコア685点（2022年6月）
  ○ 海外デザインサイトの情報収集や英語のチュートリアル理解に活用
` as const;
